export enum RewardReason {
    USER_UPDATED_PRICE ="USER_UPDATED_PRICE",
    USER_CREATE_PRICE ="USER_CREATE_PRICE",
    USER_CONFIRM_PRICE ="USER_CONFIRM_PRICE",
    PEER_CONTRIBUTED_SIMILAR_PRICE = "PEER_CONTRIBUTED_SIMILAR_PRICE"
}
